function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#1F1D4E",
  d: "M89.147 172.655l-26.93 3.318L89.175 48.704h25.551l-1.697 7.913C119.417 50.407 127.601 46 139.18 46 162.634 46 180 65.53 180 90.67c0 27.645-20.46 57.592-53.996 57.592-13.374 0-23.255-4.407-29.143-12.32l-7.714 36.713zM131.655 71.04c-14.373 0-25.551 11.217-27.348 26.341-1.996 16.226 7.686 27.043 21.559 27.043 15.77 0 27.646-13.922 27.646-30.448 0-14.022-9.082-22.936-21.857-22.936z"
}), React.createElement("path", {
  fill: "#00CB83",
  stroke: "#00CB83",
  strokeWidth: 3,
  d: "M251.463 46.5C271.623 46.5 284 60 284 79c0 3.3-.3 6.9-1.098 10.5L270.825 146h-26.15l11.678-54.4c.5-2.2.699-4.3.699-6.4 0-8-4.092-14.2-15.071-14.2-10.88 0-21.16 6.1-24.753 23l-10.978 52H180L210.541 2h26.15l-11.678 55.3c7.785-8.1 17.068-10.8 26.45-10.8z"
}), React.createElement("path", {
  stroke: "#00CB83",
  strokeWidth: 28,
  d: "M260.767 134c-17.997 64.22 5.999 130.183 34.994 121.17 28.995-9.013 30.188-99.14-273.761-52.073"
}), React.createElement("path", {
  fill: "#00CB83",
  d: "M23 189l-16 2-7 31 29-6z"
}));

var SvgPhResponsiveLogo = function SvgPhResponsiveLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 322,
    height: 270,
    viewBox: "0 0 322 270",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhResponsiveLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ph-responsive-logo.a6c2b6e3.svg";
export { ForwardRef as ReactComponent };